
(function () {
  function goToSlide(sliderEl, index) {
    var scroller = sliderEl.querySelector('.slider');
    var items = Array.prototype.slice.call(sliderEl.querySelectorAll('.slider__item:not([hidden])'));
    if (!scroller || !items[index]) return;
    var left = items[index].offsetLeft - (items[0] ? items[0].offsetLeft : 0);
    scroller.scrollTo({ left: left, behavior: 'smooth' });
    items.forEach(function (el, i) {
      el.classList.toggle('is-active', i === index);
      if (i === index) el.removeAttribute('tabindex');
      else el.setAttribute('tabindex', '-1');
    });
  }

  function buildDots(gallery) {
    if (!gallery || gallery.dataset.canesoraDots === '1') return;
    var main = gallery.querySelector('.main-image');
    if (!main) return;
    var slider = main.querySelector('carousel-slider');
    if (!slider) return;
    var items = Array.prototype.slice.call(slider.querySelectorAll('.slider__item:not([hidden])'));
    if (items.length < 2) return;

    var existing = main.parentElement && main.parentElement.querySelector(':scope > .canesora-icon-dots');
    if (existing) existing.remove();

    var nav = document.createElement('div');
    nav.className = 'canesora-icon-dots';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Product images');

    items.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Image ' + (i + 1));
      if (item.classList.contains('is-active')) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(slider, i);
        nav.querySelectorAll('button').forEach(function (b, j) {
          b.classList.toggle('is-active', j === i);
        });
      });
      nav.appendChild(btn);
    });
    if (!nav.querySelector('.is-active') && nav.firstChild) nav.firstChild.classList.add('is-active');

    main.insertAdjacentElement('afterend', nav);

    function sync() {
      items = Array.prototype.slice.call(slider.querySelectorAll('.slider__item:not([hidden])'));
      var scroller = slider.querySelector('.slider');
      var activeIndex = 0;
      if (scroller && items.length) {
        var left = scroller.scrollLeft;
        var best = 0, bestDist = Infinity;
        items.forEach(function (el, i) {
          var dist = Math.abs((el.offsetLeft - (items[0].offsetLeft || 0)) - left);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        activeIndex = best;
      }
      nav.querySelectorAll('button').forEach(function (b, j) {
        b.classList.toggle('is-active', j === activeIndex);
      });
    }

    var scroller = slider.querySelector('.slider');
    if (scroller) scroller.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    var product = gallery.closest('.js-product') || gallery.closest('[data-section-type]') || document;
    product.addEventListener('on:carousel-slider:select', sync);
    product.addEventListener('on:variant:change', function () {
      setTimeout(function () {
        gallery.dataset.canesoraDots = '';
        if (nav.parentNode) nav.remove();
        buildDots(gallery);
      }, 80);
    });

    gallery.dataset.canesoraDots = '1';
    sync();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(buildDots);
    document.querySelectorAll('.media-gallery').forEach(buildDots);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
